import { Component, OnInit, ViewEncapsulation, Input, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from "@angular/forms";
import * as moment from 'moment';
import {BusinessRulesService} from "../../../core/business-rules/business-rules.service";
import {GameScheduleInfoModel} from "../../../core/business-rules/game-schedule-info.model";
import {MessageService} from "primeng/components/common/messageservice";

@Component({
  selector: 'drawdef-time-limit',
  templateUrl: 'drawDef-time-limit.component.html',
  styleUrls: ['drawDef-time-limit.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class DrawDefTimeLimitComponent implements OnInit, AfterViewInit {

  formGroup: FormGroup;
  definition;
  definitionLoaded: boolean = false;

  @Input()
  set drawDef(value) {
    this.definition = value;
    this.setValues();
  }

  constructor(private formBuilder: FormBuilder,
              private businessService: BusinessRulesService,
              private messageService: MessageService) {
    this.formGroup = new FormGroup(
      {
        time: new FormControl()
      }
    )
  }

  private static parseTime(time : string): Date {

   let momentDate = moment();
   let data = time.split(':');

   momentDate.hours(parseInt(data[0]));
   momentDate.minutes(parseInt(data[1]));
   momentDate.seconds(0);
   momentDate.milliseconds(0);

   return momentDate.toDate();
  }

  private setValues() {

    if (this.definition) {

      this.definitionLoaded = true;
      this.formGroup.patchValue({
        time: DrawDefTimeLimitComponent.parseTime(this.definition.time),
      });
    }

  }

  ngOnInit() {
  }

  ngAfterViewInit() {
  }

  buildModel(): GameScheduleInfoModel {

    let drawTime = moment(this.formGroup.get('time').value);

    /* Se resetea segundos y milisegundos.
      (Si el usuario borro el input, el componente de primeng crea un objeto date con el valor de la fecha/hora actual) */
    drawTime.seconds(0);
    drawTime.milliseconds(0);

    let data = new GameScheduleInfoModel();
    data.gameIdentifier = parseInt(this.definition.gameIdentifier);
    data.startTime = drawTime.format('HH:mm:ss');

    return data;

  }

  onSubmit() {

    if (!this.formGroup.valid) {
      this.messageService.add({
        severity: 'warn',
        summary: '',
        detail: 'Es necesario introducir toda la información.'
      });
      return;
    }

    this.businessService.setDrawDefinitionForGame(this.definition.name.toLowerCase(), [this.buildModel()])
      .subscribe(response => {

        this.formGroup.markAsPristine();
        this.messageService.add({
          severity: 'success',
          summary: '',
          detail: 'La actualizacion fue satisfactoria.'
        });

      }, error => {
        console.error(error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error
        });
      });

  }

}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/businessRules/drawdef-time-limit/drawDef-time-limit.component.ts